export default import.meta.ROLLDOWN_FILE_URL_4ZtjpL93sTPU6gkwh4kSdw